<template>

    <b-modal :size="currentStep === 0 ? 'lg' : 'xl'" centered id="group-quote-member-add" @show="getPlansData">
        <!-- close-btn -->
        <b-button variant="close-btn" class='btn-container' @click.prevent="closeGroupQuoteModal">
            <i class="fas fa-times"></i>
        </b-button>


        <!-- modal header -->
        <div class="d-flex align-items-center justify-content-between" v-if="showHeading">
          <i class="fa-solid fa-arrow-left mb-4" v-if="currentStep === 1" @click="goBack"></i>
          <h5 class="text-center flex-grow-1"><strong> {{ actionType == 'add' ? "Add New Member" : "Update Member Details" }} </strong></h5>
        </div>
        <div id="quote-member-new">
                    <!-- row1 -->
                    <div class="row mt-2">
                            <group-member-details :groupCensusId="groupCensusId" v-if="currentStep === 0" :currentGroupPlatform="currentPlatform"/>
                            <plan-selection v-else-if="currentStep === 1" :groupCensusId="groupCensusId" quote-type="group" modal-heading="Add New Member"/>
                    </div>
        </div>
    </b-modal>
</template>


<script>
import AuthLessApi from '../../../../resource/AuthLessApi';
import Api from '../../../../resource/Api';

import GroupMemberDetails from './GroupMemberDetails.vue';
import PlanSelection from '../../../../components/PQS/PlanSelection.vue';
// import MemberPlanDetails from "./MemberPlanDetails.vue";


export default {
    name: "AddGroupQuoteMemeber",

    props: {
        groupCensusId: {
            type: [String, Number],
            required: true,
        },
        currentGroupPlatform: {
            type: String,
            required: true,
        },
        actionType: {
            type: String,
            default: "add",
            required: false,
        },
        memberToBeUpdated: {
            type: [Object, String],
            required: false,
        }
    },

    components: {
        GroupMemberDetails,
        // MemberPlanDetails,
        PlanSelection
    },

    computed:{
      currentPlatform(){
        return this.currentGroupPlatform;
      },
      currentStep(){
        return this.$store.getters.currentGroupQuoteStep;
      },
      showHeading(){
        return this.$store.getters.currentGroupQuoteStep === 0;
      }
    },

    data: () => ({
        firstName: '',
        lastName: '',
        dob: '',
        zip: '',
        tier: '',
        salary: '',
        gender: '',
        email: '',
        enrollmentPlatform: '',
        selectedPlan: '',
        selectedCategory: [],
        selectedPlanCategories: [],
        planList: [],
        planCategories: [],
        platformList: [],
        selectedTierId: '',

        selectedPlatformId: '',
        selectedItems: [],

        tierOptions: [
            { value: 'IO', text: 'Member Only' },
            { value: 'IS', text: 'Member + Spouse' },
            { value: 'IC', text: 'Member + Children' },
            { value: 'IF', text: 'Family' }
        ],
        genderOptions: [
            { value: 'M', text: 'Male' },
            { value: 'F', text: 'Female' }
        ],
    }),

    methods: {
        closeGroupQuoteModal() {
            this.$bvModal.hide("group-quote-member-add");
            this.$store.commit('setCurrentGroupQuoteStep', 0);
            this.$store.commit('setGroupMemberDetails', {});
        },

        //get plan categories
        getPlanCategories() {
            const url = "v1/get-plan-category-group";
            AuthLessApi.get(url).then((response) => {
                const categoryResponse = response.data.data;
                if (categoryResponse) {
                    categoryResponse.forEach(category => {
                        this.planCategories.push({
                            text: category[0].toUpperCase() + category.slice(1),
                            value: category
                        })
                    })
                }
            })
        },


        //fetch and populate the enrollment platform list
        getEnrollmentPlatformList() {
            Api.get("v2/quote/platform").then((response) => {
                const platformResponse = response.data;
                const list = platformResponse.data;
                if (list) {
                    this.platformList = list.map((platform) => {
                        return {
                            text: platform.platform_website,
                            value: platform.gid
                        }
                    });
                }

                this.enrollmentPlatform = this.platformList.filter(item => item.text == this.currentGroupPlatform)
            })
        },

        //get every plan related information when modal loads
        getPlansData() {
          //if user attemptes to update, populate input fields
          if (this.actionType == 'update') this.setDetailsToBeUpdated();
          else this.clearFields();
        },

        //clear input fields
        clearFields() {
            this.firstName = '';
            this.lastName = '';
            this.dob = '';
            this.zip = '';
            this.tier = '';
            this.salary = '';
            this.gender = '';
            this.email = '';
            this.enrollmentPlatform = '';
            this.selectedCategory = [];
            this.selectedPlan = [];
        },

        //construct payload from form data
        getPayload() {
            const payload = {
                group_census_id: this.groupCensusId,
                plan_type: this.tier.value,
                primary_fullname: this.firstName + this.lastName,
                first_name: this.firstName,
                last_name: this.lastName,
                relationship: "P",
                dob: this.dob,
                gender: this.gender.value == "M" ? "Male" : "Female",
                zip: this.zip,
                email: this.email,
                category: this.selectedPlanCategories
            }

            return payload;
        },

        //update vuex store and group quotes stored in the store
        updateStore() {
            this.$store.dispatch('fetchGroupQuotes');
            this.$store.commit('setActiveList', 'group');
        },

        //submit data after validation
        //update or save data based on action type
        async submitData() {
            const isValid = await this.$refs.observer.validate()
            if (!isValid) {
                return;
            }
            else {
                //call the update or add function based on action type
                if (this.actionType == 'add') await this.saveMember();
                if (this.actionType == 'update') this.updateCurrentMember();
            }
        },

        //save the details of member
        async saveMember() {
            const payload = this.getPayload();

            const selectedPlansPayload = this.selectedPlan.map(item => ({
                "plan": item.value
            }))
            const selectedCategoryPayload = this.selectedCategory.map(item => item.value);

            payload["plans"] = selectedPlansPayload;
            payload["category"] = selectedCategoryPayload
            let loader = this.$loading.show();
            try {
                const response = await Api.post(`v2/quote/store-groupquote-member`, payload)

                if (response.status == "200") {
                    this.$notify(response.data.message)
                    this.$refs.observer.reset();
                    this.clearFields();
                    this.$bvModal.hide("group-quote-member-add");
                    this.updateStore()
                }
            } catch (error) {
                console.error(error)
                this.$notify(error.response.data.message, "error")
            } finally {
                loader.hide();
            }
        },


        setPlatformValue() {
            //setting current enrollment plaform option as initial selected value
            this.enrollmentPlatform = {
                text: this.currentGroupPlatform ? this.currentGroupPlatform : "",
                value: this.currentGroupPlatform.value || this.currentGroupPlatform || ""
            }
        },

        //map values into input fields to update the memeber
        setDetailsToBeUpdated() {
            this.firstName = this.memberToBeUpdated.first_name
            this.lastName = this.memberToBeUpdated.last_name
            this.dob = this.memberToBeUpdated.dob,
                this.gender = {
                    text: this.memberToBeUpdated.gender,
                    value: this.memberToBeUpdated.gender[0].toUpperCase()
                }
            this.zip = this.memberToBeUpdated.zip
            this.salary = this.memberToBeUpdated.salary
            this.email = this.memberToBeUpdated.email
            this.tier = {
                text: this.tierOptions.filter(item => item.value == this.memberToBeUpdated.plan_type)[0].text,
                value: this.memberToBeUpdated.plan_type
            }

            this.selectedCategory = this.memberToBeUpdated.categories.map((item) => ({
                text: item[0].toUpperCase() + item.slice(1),
                value: item
            }))

            const pricingListData = JSON.parse(this.memberToBeUpdated.plan_pricing);
            if (Array.isArray(pricingListData)) {
                this.selectedPlan = pricingListData.map(item => ({
                    text: `${item.plan_name} - ${item.plan_price}`,
                    value: item.pid
                }))
            }
            else {
                this.selectedPlan = {
                    text: `${pricingListData.plan_name} - ${pricingListData.plan_price}`,
                    value: pricingListData.pid
                }
            }

        },

        //update the details of exisitng member
        updateCurrentMember() {
            const url = `v2/quote/edit-groupquote-member`
            const payload = this.getPayload();
            payload["member_id"] = this.memberToBeUpdated.id

            this.selectedPlan.value ? payload["plans"] = [{ "plan": this.selectedPlan.value.toString() }] : payload["plans"] = JSON.parse(this.memberToBeUpdated.plans)

            let loader = this.$loading.show();

            Api.put(url, payload).then((response) => {
                if (response.status == 200) {
                    this.$notify(response.data.message)
                    this.$refs.observer.reset();
                    this.clearFields();
                    this.$bvModal.hide("group-quote-member-add");
                    this.updateStore()
                }
            }).catch((err) => {
                this.$notify(err.response.data.message, "error");
                console.error(err);
            }).finally(() => {
                loader.hide()
            })
        },

      goBack(){
          this.$store.commit('setCurrentGroupQuoteStep', 0);
      }
    },

    mounted(){
        this.$store.commit('setCurrentGroupQuoteStep', 0);
        this.$store.commit("setGroupMemberDetails", {})
    },
}
</script>


<style scoped>
.multiselect {
    margin-left: 0 !important;
    width: 100% !important;
}

@media (max-width:767px) {
    .new-quote-btn {
        float: right;
    }
}

#group-quote-member-add .btn-container  {
  position: absolute;
  top: -14px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>